<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <section class="about-jtc top-background no-printme">
    <div class="background-image">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">الرئيسية</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              تسجيل الدخول
            </li>
          </ol>
        </nav>
        <h1 class="sub-title">تسجيل الدخول</h1>
      </div>
    </div>
  </section>

  <div class="intro2 section-padding">
    <div class="loading-indicator" *ngIf="global.spinner">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>

    <!-- Our Services -->
    <!-- <div class="container-fluid">
      <div class="OurServices"> -->
    <!-- <div class="row text-white justify-content-around">

            <div class="col-lg-2 col-md-4 service bg-site-color py-3 mb-1 border-left-1 pointer border-raduis-br-bl">
              <h3 class="text-center font-size-20 mb-3" style="min-height: 50px;"> تعريف التلعثم/ التأتأة </h3>
              <div class="icon-container flex justfy-center">
                <div class="video-container">
                  <video width="100%" height="130" controls style="border-radius:10px ;">
                    <source src="https://mcsc-saudi.com/api/media/Introduction.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>

          </div> -->

    <!-- <div class="row ServiceCollection text-white justify-content-around">
          <div
            class="col-lg-2 col-md-4 service bg-site-color py-3 mb-1 border-left-1 pointer border-raduis-br-bl"
          >
            <h3 class="text-center font-size-20 mb-3" style="min-height: 50px">
              تعريف التلعثم/ التأتأة
            </h3>
            <div class="icon-container flex justfy-center"> -->
    <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
    <!-- <div class="video-container">
                <video
                  width="300"
                  controls
                  style="border-radius: 10px; width: 100%; height: auto"
                >
                  <source
                    src="https://mcsc-saudi.com/api/media/Introduction.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div> -->

    <!-- (click)="showPatientRecord('مقدمة عن المنصة العلاجية.mp4')" -->
    <!-- <div
            class="col-lg-2 col-md-4 service bg-site-color py-3 mb-1 border-left-1 pointer border-raduis-br-bl"
          >
            <h3 class="text-center font-size-20 mb-3" style="min-height: 50px">
              مقدمة عن المنصة العلاجية
            </h3>
            <div class="icon-container flex justfy-center"> -->
    <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
    <!-- <div class="video-container">
                <video
                  width="300"
                  controls
                  style="border-radius: 10px; width: 100%; height: auto"
                >
                  <source
                    src="../../../assets/videos/مقدمة عن المنصة العلاجية.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div> -->

    <!-- (click)="showPatientRecord('الاسس التي بني عليها البرنامج العلاجي.mp4')" -->
    <!-- <div
            class="col-lg-2 col-md-4 service bg-site-color py-3 mb-1 border-left-1 pointer border-raduis-br-bl"
          >
            <h3 class="text-center font-size-20 mb-3" style="min-height: 50px">
              الاسس التي بني عليها البرنامج العلاجي
            </h3>
            <div class="icon-container flex justfy-center"> -->
    <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
    <!-- <div class="video-container">
                <video
                  width="300"
                  controls
                  style="border-radius: 10px; width: 100%; height: auto"
                >
                  <source
                    src="../../../assets/videos/الاسس التي بني عليها البرنامج العلاجي.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div> -->

    <!-- (click)="showPatientRecord('كيفية الاشتراك في المنصة.mp4')" -->
    <!-- <div
            class="col-lg-2 col-md-4 service bg-site-color py-3 mb-1 border-left-1 pointer border-raduis-br-bl"
          >
            <h3 class="text-center font-size-20 mb-3" style="min-height: 50px">
              كيفية الاشتراك في المنصة
            </h3>
            <div class="icon-container flex justfy-center"> -->
    <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
    <!-- <div class="video-container">
                <video
                  width="300"
                  controls
                  style="border-radius: 10px; width: 100%; height: auto"
                >
                  <source
                    src="../../../assets/videos/كيفية الاشتراك في المنصة.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div> -->

    <!-- (click)="showPatientRecord('مرحلة التشخيص.mp4')" -->
    <!-- <div
            class="col-lg-2 col-md-4 service py-3 mb-1 bg-site-color border-left-1 pointer border-raduis-br-bl"
          >
            <h3 class="text-center font-size-20 mb-3" style="min-height: 50px">
              مرحلة التشخيص
            </h3>
            <div class="icon-container flex justfy-center"> -->
    <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
    <!-- <div class="video-container">
                <video
                  width="300"
                  controls
                  style="border-radius: 10px; width: 100%; height: auto"
                >
                  <source
                    src="../../../assets/videos/مرحلة التشخيص.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div> -->

    <!-- (click)="showPatientRecord('مرحلة الجلسات العلاجية.mp4')" -->
    <!-- <div
            class="col-lg-2 col-md-4 service py-3 mb-1 bg-site-color border-left-1 pointer border-raduis-br-bl"
          >
            <h3 class="text-center font-size-20 mb-3" style="min-height: 50px">
              مرحلة الجلسات العلاجية
            </h3>
            <div class="icon-container flex justfy-center"> -->
    <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
    <!-- <div class="video-container">
                <video
                  width="300"
                  controls
                  style="border-radius: 10px; width: 100%; height: auto"
                >
                  <source
                    src="../../../assets/videos/مرحلة الجلسات العلاجية.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="container">
      <!-- <h4 class="sub-title">تسجيل <span>الدخول</span></h4> -->
      <div class="row g-24 justify-content-center">
        <div class="col-lg-6">
          <div class="card-light-border login-card">
            <form #f="ngForm" novalidate (ngSubmit)="login(f)">
              <div class="row">
                <div class="col-12">
                  <div class="inputs">
                    <div class="single-input-container mb-3">
                      <label class="form-input-label"> اسم المستخدم </label>
                      <div class="single-input">
                        <input
                          id="email"
                          required
                          name="email"
                          class="form-control"
                          type="text"
                          placeholder=" {{ 'form.email' | translate }}"
                          [ngModel]="credentials.email"
                          #email="ngModel"
                          tmFocus
                          validateEmail
                        />
                      </div>
                    </div>

                    <div class="single-input-container">
                      <label class="form-input-label"> الرقم السري </label>
                      <div class="single-input">
                        <input
                          class="form-control"
                          type="password"
                          id="password"
                          #password="ngModel"
                          required
                          name="password"
                          placeholder=" {{ 'form.password' | translate }}"
                          ngModel
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-md-6 col-sm-6 col-12">
                  <label class="ui-form-input-container">
                    <input
                      id="email"
                      required
                      name="email"
                      class="ui-form-input"
                      type="text"
                      placeholder=" {{ 'form.email' | translate }}"
                      [ngModel]="credentials.email"
                      #email="ngModel"
                      tmFocus
                      validateEmail
                    />
                    <span class="form-input-label">اسم المستخدم</span>
                  </label>
                </div>
                <div class="col-md-6 col-sm-6 col-12">
                  <label class="ui-form-input-container">
                    <input
                      class="ui-form-input"
                      type="password"
                      id="password"
                      #password="ngModel"
                      required
                      name="password"
                      placeholder=" {{ 'form.password' | translate }}"
                      ngModel
                    />
                    <span class="form-input-label">الرقم السري</span>
                  </label>
                </div> -->
              </div>
              <div class="ui-dev">
                <!-- <button
                  type="submit"
                  class="login-form"
                  [disabled]="f.invalid || isRequesting"
                >
                  {{ "form.login" | translate }}
                </button> -->
                <button
                  type="submit"
                  class="login-form btn btn-primary"
                  [disabled]="f.invalid || isRequesting"
                >
                  {{ "form.login" | translate }}
                </button>
                <div class="d-flex space-around" style="margin: 2rem 0rem">
                  <div class="">
                    <label class="custom-control custom-checkbox d-flex">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="item_checkbox"
                        name="item_checkbox"
                        value="option1"
                      />
                      <span class="custom-control-label">&nbsp;تذكرني</span>
                    </label>
                  </div>
                  <div class="">
                    <a [routerLink]="['/ForgetPasswordEmail']" class="forget">
                      {{ "form.forget-pass" | translate }}</a
                    >
                  </div>
                  <!-- <div class="">
                                    <a href="" class="forget">نسيت كلمة المرور ؟ </a>
                                </div> -->
                </div>
                <!-- <div class=" d-flex justify-content-between">
                                <div class="icon_link">
                                    <a href="" class=""><img src="assets/images/facebook.png" class="img-fluid"
                                            width="35"></a>
                                </div>
                                <div class="icon_link">
                                    <a href="" class=""><img src="assets/images/google.png" class="img-fluid" width="35">
                                    </a>
                                </div>
                            </div> -->
                <div class="new-lik">
                  <a [routerLink]="['/register']"
                    >ليس لديك حساب <span>تسجيل مستخدم جديد</span></a
                  >
                </div>
              </div>
            </form>
          </div>
        </div>

        <!-- <div class="col-lg-6">
          <div class="row g-24">
            <div class="col-lg-6">
              <div class="card-light-border video-card">
                <video controls>
                  <source
                    src="https://mcsc-saudi.com/api/media/Introduction.mp4"
                    type="video/mp4"
                  />
                </video>
                <h3>تعريف التلعثم/ التأتأة</h3>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card-light-border video-card">
                <video controls>
                  <source
                    src="../../../assets/videos/مقدمة عن المنصة العلاجية.mp4"
                    type="video/mp4"
                  />
                </video>
                <h3>مقدمة عن المنصة العلاجية</h3>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card-light-border video-card">
                <video controls>
                  <source
                    src="../../../assets/videos/الاسس التي بني عليها البرنامج العلاجي.mp4"
                    type="video/mp4"
                  />
                </video>
                <h3>الاسس التي بني عليها البرنامج العلاجي</h3>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card-light-border video-card">
                <video controls>
                  <source
                    src="../../../assets/videos/كيفية الاشتراك في المنصة.mp4"
                    type="video/mp4"
                  />
                </video>
                <h3>كيفية الاشتراك في المنصة</h3>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card-light-border video-card">
                <video controls>
                  <source
                    src="../../../assets/videos/مرحلة التشخيص.mp4"
                    type="video/mp4"
                  />
                </video>
                <h3>مرحلة التشخيص</h3>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card-light-border video-card">
                <video controls>
                  <source
                    src="../../../assets/videos/مرحلة الجلسات العلاجية.mp4"
                    type="video/mp4"
                  />
                </video>
                <h3>مرحلة الجلسات العلاجية</h3>
              </div>
            </div>
          </div>
        </div> -->

        <div
          class="col-lg-8 text-center"
          style="font-size: 60px"
          *ngIf="showLogin"
        >
          <h1 class="mb-0" style="color: #34bbe3">قريباً..</h1>
          <img
            src="../../../assets/images/soon.gif"
            class="img-fluid rounded"
            style="margin-top: -20px"
            width="70%"
          />
        </div>

        <!-- <div class="col-lg-4">
                  <div class="last-news">
                      <h5 class="title">أخر <span>الأخبار</span> </h5>

                      <div class="lat-single row">
                          <div class="col-3">
                              <div class="thumb">
                                  <p>13</p>
                                  <small>يونيو 2021</small>
                              </div>
                          </div>
                          <div class="col-9">
                              <div class="cnt">
                                  <h2>
                                      <a href=""> الحمد لله رب العالمين، والصلاة والسلام على أشرف الأنبياء والمرسلين نبينا
                                          محمد أما بعد ...

                                      </a>
                                  </h2>

                              </div>
                          </div>
                      </div>
                      <div class="lat-single row">
                          <div class="col-3">
                              <div class="thumb">
                                  <p>13</p>
                                  <small>يونيو 2021</small>
                              </div>
                          </div>
                          <div class="col-9">
                              <div class="cnt">
                                  <h2>
                                      <a href=""> الحمد لله رب العالمين، والصلاة والسلام على أشرف الأنبياء والمرسلين نبينا
                                          محمد أما بعد ...

                                      </a>
                                  </h2>

                              </div>
                          </div>
                      </div>
                      <div class="lat-single row">
                          <div class="col-3">
                              <div class="thumb">
                                  <p>13</p>
                                  <small>يونيو 2021</small>
                              </div>
                          </div>
                          <div class="col-9">
                              <div class="cnt">
                                  <h2>
                                      <a href=""> الحمد لله رب العالمين، والصلاة والسلام على أشرف الأنبياء والمرسلين نبينا
                                          محمد أما بعد ...

                                      </a>
                                  </h2>

                              </div>
                          </div>
                      </div>
                      <a href="#" class="Left_link">عرض الكل <i class="fas fa-chevron-left"></i></a>
                      <br>
                      <div class="tabs">
                        <div class="tab2 tab">
                          <div class="phone">
                              <img src="assets/images/telephone.png" class="img-fluid" width="50">
                              <div class="content">
                                  <span>اتصل بنا</span>
                                  <p>هل لديك استفسار بخصةص خدماتنا</p>
                              </div>
                          </div>
                        </div>
                        <div class="tab3 tab">
                          <div class="phone">
                            <img src="assets/images/team.png" class="img-fluid" width="50">
                            <div class="content">
                                <span>انضم لفريقنا</span>
                                <p>في حلول التواصل الطبية</p>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
              </div> -->
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>
</div>
